import { Theme } from '@material-ui/core/styles';

export const getMuiDialogActions = (theme: Theme): Record<string, unknown> => ({
  MuiDialogActions: {
    root: {
      borderTop: `1px solid ${theme.palette.grey[400]}`,
      flexDirection: 'column',

      '& .MuiButton-fullWidth': {
        '&:first-of-type:not(:last-of-type)': {
          marginBottom: theme.spacing(1),
        },

        '&:last-child': {
          marginLeft: 0,
        },
      },
    },
  },
});
